(() => {
  const initialize = (bar) => {
    if (bar.dataset.initialized === 'true') return;
    bar.dataset.initialized = 'true';

    const section = bar.closest('[data-section]');
    const mainButton = section && section.querySelector('.product-form__submit');
    const stickyButton = bar.querySelector('.anteplim-mobile-buybar__button');
    const stickyPrice = bar.querySelector('.anteplim-mobile-buybar__price');
    const priceSource = section && section.querySelector('[id^="price-"]');
    const cartDrawer = document.querySelector('cart-drawer');
    if (!section || !mainButton || !stickyButton) return;

    const sync = () => {
      const unavailable = mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true';
      stickyButton.disabled = unavailable;
      stickyButton.textContent = unavailable ? bar.dataset.soldOutText : bar.dataset.addText;
      if (stickyPrice && priceSource) {
        const activePrice = priceSource.querySelector('.price-item--sale, .price-item--regular');
        if (activePrice) stickyPrice.textContent = activePrice.textContent.trim();
      }
    };

    const setVisibility = () => {
      const passedMainButton = mainButton.getBoundingClientRect().bottom < 1;
      const cartIsOpen = cartDrawer && cartDrawer.classList.contains('active');
      const shouldShow = passedMainButton && !cartIsOpen;
      bar.classList.toggle('is-visible', shouldShow);
      bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      document.body.classList.toggle('anteplim-buybar-visible', shouldShow);
    };

    stickyButton.addEventListener('click', () => {
      if (!stickyButton.disabled) mainButton.click();
    });

    new MutationObserver(sync).observe(mainButton, {
      attributes: true,
      childList: true,
      subtree: true
    });
    if (priceSource) new MutationObserver(sync).observe(priceSource, { childList: true, subtree: true });
    if (cartDrawer) new MutationObserver(setVisibility).observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
    let ticking = false;
    const requestVisibilityUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        setVisibility();
        ticking = false;
      });
    };
    window.addEventListener('scroll', requestVisibilityUpdate, { passive: true });
    window.addEventListener('resize', requestVisibilityUpdate);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', requestVisibilityUpdate);
      window.visualViewport.addEventListener('scroll', requestVisibilityUpdate);
    }
    sync();
    setVisibility();
  };

  const initializeAll = () => {
    document.querySelectorAll('[data-anteplim-mobile-buybar]').forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll);
  } else {
    initializeAll();
  }
  document.addEventListener('shopify:section:load', initializeAll);
})();
